import * as React from 'react';
import { useSelector } from 'react-redux';

import { NewbuildingInfoDesktop } from '../../components/NewbuildingInfo';
import { selectTotalImagesCount } from '../../selectors/constructionProgress';
import { selectNewbuilding } from '../../selectors/newbuilding';

import { ProblemChoicePopupContainer } from '../ProblemChoicePopup';
import { ReliableChoicePopupContainer } from '../ReliableChoicePopup';

import { getNewbuildingLinks, getNewbuildingStatuses } from './helpers';
import { FavoriteButtonDesktopWithMotivation } from './parts/FavoriteButtonDesktopWithMotivation';

export const NewbuildingInfoDesktopContainer: React.FC = () => {
  const newbuilding = useSelector(selectNewbuilding);
  const totalImagesCount = useSelector(selectTotalImagesCount);

  const newbuildingInfo = React.useMemo(
    () => ({
      links: getNewbuildingLinks(newbuilding.url),
      statuses: getNewbuildingStatuses(newbuilding, totalImagesCount),
    }),
    [newbuilding, totalImagesCount],
  );

  return (
    <NewbuildingInfoDesktop
      favoriteButton={<FavoriteButtonDesktopWithMotivation />}
      problemLabel={<ProblemChoicePopupContainer />}
      reliableLabel={<ReliableChoicePopupContainer />}
      newbuildingImage={newbuilding.imgUrl}
      newbuildingName={newbuilding.name}
      housesByTurn={newbuilding.housesByTurnDisplay}
      links={newbuildingInfo.links}
      statuses={newbuildingInfo.statuses}
    />
  );
};
